Vue.config.appVersion = 20200818;
import version_control from './store/versioncontrol.js';

import Vue from 'vue'
import App from './App'
import vuetify from './plugins/vuetify';
import store from "./store/store";
import router from './router/index';

import theme from './theme/theme_gide.js';
import board_utility from "./store/board_utility.js";

  
Vue.config.productionTip = false;

Vue.prototype.$theme = theme;

import socketio from 'socket.io-client';


window.addEventListener("flutterInAppWebViewPlatformReady", function (event) {
  console.log("flutterInAppWebViewPlatformReady NOW", event)
})

if (navigator.userAgent.toLowerCase().includes("gide_ios")) {
  window.__IS_APP__ = true
  window.__DEVICE_OS__ = "ios"
  window.__IS__MOBILE_DEVICE__ = true
}
else if(navigator.userAgent.toLowerCase().includes("gide_android")) {
  window.__IS_APP__ = true
  window.__DEVICE_OS__ = "android"
  window.__IS__MOBILE_DEVICE__ = true
}
else if(navigator.userAgent.toLowerCase().includes("iphone")
  || navigator.userAgent.toLowerCase().includes("ipod")
  || navigator.userAgent.toLowerCase().includes("ipad")
){
  window.__IS_APP__ = false
  window.__IS__MOBILE_DEVICE__ = true
  window.__DEVICE_OS__ = "ios"
}
else if(navigator.userAgent.toLowerCase().includes("android")) {
  window.__IS_APP__ = false
  window.__IS__MOBILE_DEVICE__ = true
  window.__DEVICE_OS__ = "android"  
}
else {
  window.__IS_APP__ = false  
  window.__IS__MOBILE_DEVICE__ = false
  window.__DEVICE_OS__ = "web"  
}

//https://stackoverflow.com/questions/28238628/socket-io-1-x-use-websockets-only/28240802#28240802
export var socket = socketio(process.env.VUE_APP_MESH_API, {transports: ['websocket'], upgrade: false, secure: false});
if(socket){ 
  if (process.env.VUE_APP_DEBUG == "true") {console.log("New Socket Connected", socket);}
  store.commit("setSocket", socket);
}

socket.on("disconnect", function() {
  if (process.env.VUE_APP_DEBUG == "true") {console.log("Disconnected");}  
});

socket.on("reconnect", function() {
  if (process.env.VUE_APP_DEBUG == "true") {console.log("Reconnecting");}
});

socket.on("connect", async function() {
  if (process.env.VUE_APP_DEBUG == "true") {console.log("Connected After Reconnect");}
  
  let user_id = null;
  try{
    user_id = await store.getters.userData.user_id;
  }
  catch(error){
    if (process.env.VUE_APP_DEBUG == "true") {console.log("User Id Missing during socket reconnect");}
  }
  
  if(user_id){
    //Get GroupList from Cache & Subscribe the user to the group Ids
    var my_group_ids = {};
    let chatgrpList_ls = await store.getters.getChatgrpList;
    chatgrpList_ls = chatgrpList_ls ? chatgrpList_ls : null;
  
    if(chatgrpList_ls){
      Object.keys(chatgrpList_ls).forEach(function(index) {
        my_group_ids[chatgrpList_ls[index].group_id] = chatgrpList_ls[index].group_id;
      }); 
    
        socket.emit('subscribe_group_id_list', user_id, my_group_ids);
    }
  
    //Get Contact List from Cache & Subscribe the user to the Contact Ids
    let UserContactList = await store.getters.getUserContactList;
    if(UserContactList){
        socket.emit('subscribe_contact_id_list', user_id, UserContactList);  
    }

    //Subscribe to Account Id
    store.commit('setRefreshSubscribeAccountIdList', Math.random());
  }
});

//Refresh the list on Windows focus
window.onfocus = async function() {
  if (process.env.VUE_APP_DEBUG == "true") {console.log("Window in Focus");}
  store.commit('setRefreshChatGrpList', Math.random());  
};

import socket_listener from "./store/socket_listener";
Vue.prototype.$socket_listener= new socket_listener();

//Save the Height of the Device
store.commit('setClientDeviceHeight', window.innerHeight);

//Authentication
router.beforeEach(async (to, from, next) => {
  version_control.vc20200818(Vue.config.appVersion, to);
  //Check if User is Authenticated
  if (to.matched.some(record => record.meta.requiresAuth)) {
    let add_to_chatgrp_query = '';

    //To handle page refresh and back navigation while editing a card
    if(from.name == 'boards' || (!from.name && to.name == 'boards')) {
      board_utility.unlock_card(Vue);
    }

    let inviteGroupId = await store.getters.inviteGroupId;
    var group_id = to.query.id ? to.query.id : inviteGroupId; //Either from query string or cache
    if(group_id){
      //This is reset after user gets added to the group
      //In case the user presses the back button then the query string may get lost. So save it in cache
      await store.commit("setInviteGroupId", group_id);
      //If changing here pls ensure to change in autologin.js and chat_content.vue
      add_to_chatgrp_query = "?id="+group_id;
    }

    if (!store.getters.loggedIn) {
      //Not logged in redirect to login page.
      let redirectUri = "/login";
      console.log("I am redirecting")

      //APPLE LOGIN POPUP FAILED, SO LOGIN VIA REDIRECT
      if(to.query.f){
        redirectUri += "?f="+to.query.f;        
      }
      else if(decodeURIComponent(window.location.href.split("?")[1]).indexOf('uri=') !== -1){
        //Deep Link Handling for Not logged User. Redirect to the URL passed in "uri" Param 
        let decodedURI = decodeURIComponent(window.location.href.split("?")[1]);
        redirectUri = '/'+decodedURI.replace('uri=', "");//We dont need the string uri=
        if (process.env.VUE_APP_DEBUG == "true") {console.log("Found Encoded URL. Not Logged In User, Redirect To => ", redirectUri);}
      }

      next({
        path: redirectUri
      })
    }
    else if (to.path === '/quick-profile' && group_id && store.getters.loggedIn && store.getters.userData.is_verified == 1) {
      //User is loggedin via mobile or google, has been verfied and had come to this site via invite and tried to route into quick profile.
      //This will happen after signup, quick profile, and user got added to chat group and clicks the back button
      next({
        path: '/chatgrp_add_invite'+add_to_chatgrp_query
      })
    }
    else if (to.path == '/' 
      && store.getters.userData 
      && store.getters.loggedIn 
      && store.getters.userData.is_verified) {
      next({
        path: '/chat'
      })
    }
    else if (to.path == '/deeplink_to_message' 
      && store.getters.userData       
      && store.getters.loggedIn 
      && store.getters.userData.is_verified) {
      //Deeplink will not work if the user is not logged in and should have some chats

      //Get GroupId and MessageId from query String
      store.commit('setSelectedGroup', to.query.group_id);
      
      let deeplinkmsgobj = {}
      deeplinkmsgobj['this_message_id'] = to.query.this_message_id;
      deeplinkmsgobj['id'] = parseInt(to.query.msg_auto_id);//Mysql Auto Id
      store.commit('setSelectedDeeplinkMessage', deeplinkmsgobj);
      next({
        path: '/chat_message'
      })
    }
    else if (to.path == '/deeplink_to_board' 
      && store.getters.userData 
      && store.getters.loggedIn 
      && store.getters.userData.is_verified) {
      //Deeplink will not work if the user is not logged in and should have some boards

      //Get board_id and card_id from query String
      if(to.query.board_id && to.query.card_id){
        store.commit('setSelectedBoard', to.query.board_id);  
        store.commit('setSelectedDeeplinkBoardCard', to.query.card_id);
        next({
          path: '/boards/'+to.query.board_id
        })    
      }
      else{
        next({
          path: '/board_home'
        })  
      }      
    }
    else if (to.path == '/share_content' 
      && store.getters.userData 
      && store.getters.loggedIn 
      && store.getters.userData.is_verified) {
      //Get base64 encoded shared_content_data from query String  it. This is called when another app shares a text on Mesh
      let sharedContentObj = {};
      sharedContentObj['shared_content_data'] = to.query.shared_content_data;
      sharedContentObj['shared_content_data_type'] = to.query.shared_content_data_type;
      
      store.commit('setExternalAppSharedText', sharedContentObj);
      if(!to.query.module){
        to.query.module = "chat"; 
      }

      next({
        path: '/'+to.query.module //Send the Request to route as specified in the module
      })
    }
    else if(to.path != '/quick-profile' && store.getters.loggedIn && (store.getters.userData.is_verified == false || store.getters.userData.is_verified == 0)){
      //For some reason user clicked Back while on quick profile, or trying to access another route without completing profile
      next({
        path: '/quick-profile'+add_to_chatgrp_query
      })
    }
    else if(decodeURIComponent(window.location.href.split("?")[1]).indexOf('uri=') !== -1
      && store.getters.userData 
      && store.getters.userData.is_verified) {      
      //Deep Link Handling for logged User. Redirect to the URL passed in "uri" Param
      let decodedURI = decodeURIComponent(window.location.href.split("?")[1]);  
      let redirectUri = '/'+decodedURI.replace('uri=', "");//We dont need the string uri=
      if (process.env.VUE_APP_DEBUG == "true") {console.log("Found Encoded URL for Logged In User, Redirect To => ", redirectUri);}      
      window.location.href = location.protocol+'//'+location.hostname+(location.port ? ':'+location.port : '')+redirectUri;
    }
    else {
      //Goto to the clicked route
      next()
    }
  }
  else if (to.matched.some(record => record.meta.requiresVisitors)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (to.fullPath.includes("gateway")) {
      next()
    }
    else if (store.getters.loggedIn) {
      next({
        path: '/'
      })
    } 
    else {
      next()
    }
  }
  else {
    //TO be called for cases which donot need authentication
    next() // make sure to always call next()!
  }
});

new Vue({
  el: '#app',
  vuetify,
  router : router,
  store,
  render: h => h(App)
});

